import magnifiAPIInstance from "./apiInstance";

export const templateConfigAPIs = {
  getTemplateConfig: () => magnifiAPIInstance.get(`/template-config`),
  updateTemplateConfig: ({ payload }) => magnifiAPIInstance.post(`/template-config`, payload),
};
